export default __webpack_public_path__ + "src/images/packages/oceana-reserve/270fe6a93a74af86b2d1c776eba67cc8-2.jpg";